import React from "react";
import { Outlet, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

export default function CreditCardLayout() {
  const productType = useSelector((state) => state.token.productType);

  if (productType !== "Credit Cards") {
    // not the correct product type, redirect to products
    return <Navigate to={`/products`} />;
  }

  return <Outlet />;
}
